import { attr, customElement, DOM, FASTElement } from '@microsoft/fast-element';
import { ValidationGridTemplate as template } from './validation-grid.template';
import { ValidationGridStyles as styles } from './validation-grid.styles';
import { ZeroGridPro as zeroAgGrid } from '@genesislcap/foundation-zero-grid-pro';
import { ObjectValidation } from '../../../types';

const name = 'validation-grid';

export interface ValidationColumnConfig {
  fieldName: string;
  headerName: string;
  flex: number;
}

@customElement({
  name,
  template,
  styles,
})
export class ValidationGrid extends FASTElement {
  @attr objectList: Array<ObjectValidation>;
  @attr columnConfigs: Array<ValidationColumnConfig>;

  public correctVppasGrid: zeroAgGrid;

  public connectedCallback() {
    super.connectedCallback();

    DOM.queueUpdate(() => {
      this.configureGrid();
    });
  }

  private configureGrid() {
    setTimeout(() => {
      const columnDefs = [];
      const rowData = [];

      columnDefs.push({
        headerName: '',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 52,
      });

      if (this.columnConfigs.length > 0) {
        this.columnConfigs.forEach((element) => {
          columnDefs.push({
            field: element.fieldName,
            headerName: element.headerName,
            flex: element.flex,
          });
        });
      }

      if (this.objectList && this.objectList.length > 0) {
        this.objectList.forEach((element) => {
          const object = {};
          element.fields.forEach((field) => {
            object[field.fieldName] = field.fieldValue;
          });
          rowData.push(object);
        });
      }

      const gridOptions = {
        defaultColDef: {
          resizable: false,
          filter: false,
          suppressMenu: true,
        },
        columnDefs,
        scrollbarWidth: 10,
        rowData,
        rowClass: 'transparent-background',
      };

      this.correctVppasGrid.gridOptions = gridOptions;
    }, 500);
  }

  public onGridReady() {
    this.correctVppasGrid.gridApi.addEventListener('firstDataRendered', (event: any) => {
      event.api.forEachNode((node) => node.setSelected(true));
    });
    // this.correctVppasGrid.columnApi?.autoSizeAllColumns();
  }

  objectListChanged(oldValue, newValue) {
    if (this.correctVppasGrid) {
      this.configureGrid();
    }
  }
}
